<template>
  <div>
    <el-card>
      <div style="float: right">
        <yearcomponent @change="handler_year" />

        <el-select
          v-model="valueCompanys"
          v-bind="$attrs"
          size="mini"
          placeholder="Select"
          v-loading="loading"
        >
          <el-option
            v-for="item in companys"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>

      <div style="margin-top: 50px">
        <rabbey-table3
          :columns="months"
          :data="dataReStatus"
          :loading="loading"
          :maxheight="1000"
          :paginationApi="{
            currentPage: 1,
            pageSize: 200
          }"
          :pageSizes="[200, 400, 600]"
          default-expand-all
        ></rabbey-table3>
      </div>
    </el-card>
  </div>
</template>

<script>
// import { Months } from "@/helpers/MonthsColumns";
import ReasonFiancialColumns from "@/views/modules/Status/columns/ReasonFiancialColumns";
import yearcomponent from "@/components/Global_System/YearsComponent";

export default {
  name: "ReasonFinancial",
  components: { yearcomponent },
  data() {
    return {
      months: ReasonFiancialColumns,
      loading: false,
      companys: [
        {
          value: 4,
          label: "Magycorp Technologies"
        },
        {
          value: 5,
          label: "Magycorp SA"
        },
        {
          value: 2,
          label: "MAGYTRACK"
        },
        {
          value: 1,
          label: "TENNOS BUSINESS"
        },
        {
          value: 6,
          label: "RABBEY"
        },
        {
          value: 0,
          label: "Consolidado"
        }
      ],
      dataReStatus: [],
      year: 2023,
      valueCompanys: 4
    };
  },
  mounted() {
    this.GetReasonFiancial();
  },
  methods: {
    handler_year(_year) {
      this.year = _year;
      this.GetReasonFiancial();
    },
    GetReasonFiancial() {
      this.loading = true;

      var params = {
        year: this.year,
        option: this.valueCompanys
      };
      this.$http
        .get(`/api/resultsStatus/GetReasonFiancial`, {
          params: params
        })
        .then((resp) => {
          this.loading = false;
          // console.logvalueMoney;
          this.dataReStatus = resp.data;
          // this.dataReStatus = resp.data.filter(
          //   (request) => request.nombre != ""
          // );
        })
        .catch(() => {
          this.loading = false;
        })
        .finally(() => (this.loading = false));
    }
  },
  watch: {
    valueCompanys() {
      this.GetReasonFiancial();
    },
    year() {
      this.GetReasonFiancial();
    }
  }
};
</script>

<style scoped></style>
